package br.com.vvrefeicoes.portal.domain.model

data class HomeAnnouncement(
    val id: String,
    val title: String,
    val body: String,
    val imageUrl: String?,
    val publishedAt: String?,
    val authorName: String,
)

data class HomeData(
    val announcements: List<HomeAnnouncement>,
    val operationalComplete: Boolean,
    val purchasesComplete: Boolean,
)
